import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { updateProductStatus } from "../../../../api/products";
import { requestTableRefresh } from "../../../../reducers/userConfigSlice";
import { translateMessage } from "@delibrandev/utils";

export const ProductStatusToggle = ({
  productId,
  name,
  status,
  presentation = "switch",
  onConfirmed,
  onBusyChange,
}) => {
  const dispatch = useDispatch();
  const [current, setCurrent] = useState(status);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false);
  useEffect(() => setCurrent(status), [status]);
  const toggle = async () => {
    if (pending.current) return;
    pending.current = true;
    onBusyChange?.(true);
    setBusy(true);
    setError("");
    const next = current === "PUBLISHED" ? "DRAFT" : "PUBLISHED";
    try {
      const response = await updateProductStatus(productId, next);
      if (response?.error !== false || response.data !== next) {
        throw new Error(
          response?.message || "No se pudo cambiar el estado del producto",
        );
      }
      setCurrent(next);
      dispatch(requestTableRefresh());
      onConfirmed?.();
    } catch (failure) {
      setError(translateMessage(failure.message));
    } finally {
      pending.current = false;
      setBusy(false);
      onBusyChange?.(false);
    }
  };
  return (
    <div className="productPublication" aria-busy={busy}>
      {presentation === "menu" ? (
        <button type="button" disabled={busy} onClick={toggle}>
          {busy
            ? "Guardando…"
            : current === "PUBLISHED"
              ? "Guardar como borrador"
              : "Publicar"}
        </button>
      ) : (
        <label
          className={`productPublicationControl ${current === "PUBLISHED" ? "is-published" : ""}`}
        >
          <input
            type="checkbox"
            role="switch"
            aria-label={`Publicado: ${name}`}
            checked={current === "PUBLISHED"}
            disabled={busy}
            onChange={toggle}
          />
          <span className="productPublicationTrack" aria-hidden="true" />
          <span>{current === "PUBLISHED" ? "Publicado" : "Borrador"}</span>
        </label>
      )}
      {busy && <span role="status">Guardando…</span>}
      {error && <span role="alert">{error}</span>}
    </div>
  );
};
